import React from "react";
import { Outlet } from "react-router-dom";
import NavigationBar from "../NavigationBar";
import ProtectedRoute from "../../routes/ProtectedRoute";

/**
 * AccountLayout Component
 * Main layout wrapper for authenticated pages
 * Includes navigation bar and outlet for nested routes
 */
const AccountLayout = () => {
  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50">
        <NavigationBar />
        <main id="main-content" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
          <Outlet />
        </main>
      </div>
    </ProtectedRoute>
  );
};

export default AccountLayout;